import React, { useState, useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import FormHandler from "../../Common/Form/FormHandler/FormHandler";
import useFormPersist from "react-hook-form-persist";
import "./CreateResourceRegForm.css";
import { useTranslation } from 'react-i18next';
import {
  postDataWithBody,
  getData,
  putDataWithBody,
} from "../../../../Services/Services";
import { yupResolver } from "@hookform/resolvers/yup";
import Loader from "react-spinner-loader";
import {
  schema,
  resourceFormConfig,
} from "../../../../JsonData/CreateResourceEntityConfig";
import {
  resourceCatListURL,
  findResourcesById,
  updateResourceURL,
  getContacts,
  createResourceURL,
  regionListURL,
  agencyListURL,
  getFacilities,
  resourceActivityListURL,
  resourceNameListURL,
  getRestrictedRegionListURL,
  facilityListByRegionId,
  getContactsForAgency,
  getThemeURL,
} from "../../../../Services/EndPoints";

const CreateResourceRegForm = ({inEdit}) => {
  const [loader, setLoader] = useState(false);
  const [resourceConfig, setResourceConfig] = useState(resourceFormConfig);
  const [facilityData, setFacilityData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [agencyData, setAgencyData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [resourcedataById, setResourcedataById] = useState(null);
  const [regionChanged, isRegionChanged] = useState(false);
  const [regionDataSelected, setRegionDataSelected] = useState([]);
  const [RegionNew, setRegionNew] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [resourceActivityList, setResourceActivityList] = useState([]);
  const [resourceNameList, setResourceNameList] = useState([]);
  const { t } = useTranslation();
  const [resourceCategoriesList, setResourceCategoriesList] = useState([]);
  const [isRegionChanging, setIsRegionChanging] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const { state } = useLocation();
  const [stateId, setStateId] = useState(null);
  let id = state?.data;
  let edit = state?.edit;
  console.log(id, "resourcedata");
  
  let contactIdListGlobal = [],
    agencyIdListGlobal = [],
    regionidlistGlobal = [];
    
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema[activeTab]), mode: "all" });
  
  const rscractivity = useWatch({
    control,
    name: "rsrc_activity_id",
  });
  
  const rscrcat = useWatch({
    control,
    name: "rsrc_cat_id",
  });
  
  // Watch for region changes
  const selectedRegion = useWatch({
    control,
    name: "region",
  });

  const totalQuantity = useWatch({
    control,
    name: "total_quantity",
  });
  
  const damagedQuantity = useWatch({
    control,
    name: "damaged_quantity",
  });

  const deployedQuantity = useWatch({
    control,
    name: "deploy_quantity",
  });

  const selectedAgency = useWatch({
    control,
    name: "agency_id", // Replace with your actual agency field name
  });
  console.log("selctedagency",selectedAgency)
  // Add this useEffect to handle agency selection changes
  const [originalAgencyId, setOriginalAgencyId] = useState(null);
  const [isAgencyChanging, setIsAgencyChanging] = useState(false);
   
  // Modified useEffect to handle agency selection changes
  useEffect(() => {
    if (selectedAgency && selectedAgency !== "") {
      console.log("Selected agency:", selectedAgency);
      console.log("Original agency ID:", originalAgencyId);
      // Check if this is a user-initiated change in edit mode
      if (id && originalAgencyId !== null) {
        // In edit mode, check if agency actually changed
        if (String(originalAgencyId) !== String(selectedAgency)) {
          // Agency was changed by user - clear contacts
          console.log("Agency changed from", originalAgencyId, "to", selectedAgency, "- clearing contacts");
          setIsAgencyChanging(true);
          // Clear the contact selection BEFORE fetching new contacts
          setValue("contact_list", [], { shouldDirty: true, shouldTouch: true });
          trigger("contact_list");
          // Force DOM clearing
          const contactElement = document.getElementById("contact_list");
          if (contactElement) {
            contactElement.value = "";
            contactElement.dispatchEvent(new Event("change", { bubbles: true }));
          }
          // Add a small delay to ensure clearing happens before new data loads
          setTimeout(() => {
            getContactList(selectedAgency,true);
          }, 50);
          return;
        } else {
          // Same agency as original - don't set isAgencyChanging
          setIsAgencyChanging(false);
        }
      } else if (!id) {
        // Create mode - always clear when agency changes (except initial load)
        if (originalAgencyId !== null) {
          console.log("Create mode - clearing contacts for agency change");
          setValue("contact_list", [], { shouldDirty: true, shouldTouch: true });
          trigger("contact_list");
        }
      }
      // Fetch new contact list
      getContactList(selectedAgency);
    } else if (selectedAgency === "") {
      // If "Select Agency" is chosen, clear the contact list
      setValue("contact_list", [], { shouldDirty: true, shouldTouch: true });
      trigger("contact_list");
      const updatedConfig = [...resourceConfig];
      updatedConfig[0].fields[10]["options"] = [];
      setResourceConfig(updatedConfig);
      setContactData([]);
    }
  }, [selectedAgency, originalAgencyId]);


  useEffect(() => {
    const total = parseInt(totalQuantity) || 0;
    const damaged = parseInt(damagedQuantity) || 0;
    const deployed = parseInt(deployedQuantity) || 0;
    const available = total - damaged - deployed;
    
    // Only set if the calculated value is different from current value
    const currentAvailable = getValues("available_quantity");
    if (currentAvailable !== available) {
      setValue("available_quantity", available >= 0 ? available : 0);
    }
  }, [totalQuantity, damagedQuantity, deployedQuantity, setValue, getValues]);

  // Log when the selected region changes and fetch facilities
  useEffect(() => {
    if (selectedRegion && selectedRegion.value) {
      console.log("Selected Region ID:", selectedRegion.value);
      
      // Only clear facility and mark as changed if this is a user-initiated change
      // and not during initial population
      if (id && resourcedataById) {
        // Check if the selected region is different from the original region
        const originalRegionId = resourcedataById.resource_region_map?.[0]?.region_id;
        const currentRegionId = selectedRegion.value;
        
        if (originalRegionId && String(originalRegionId) !== String(currentRegionId)) {
          // User changed the region - clear facility
          setValue("facility_id", null, { shouldDirty: true, shouldTouch: true });
          trigger("facility_id");
          setFacilityData([]);
          
          // Update form config to clear facility options
          const updatedConfig = [...resourceConfig];
          updatedConfig[0].fields[9].options = [];
          setResourceConfig(updatedConfig);
          
          // Force the DOM element to clear if it exists
          const facilityElement = document.getElementById("facility_id");
          if (facilityElement) {
            facilityElement.value = "";
            facilityElement.dispatchEvent(new Event("change", { bubbles: true }));
          }
          
          // Mark region as changed for edit mode
          isRegionChanged(true);
        }
      } else if (!id) {
        // For create mode, always mark as changed
        isRegionChanged(true);
      }
      
      getFacilityListByRegion(selectedRegion.value);
    }
  }, [selectedRegion]);

  useEffect(() => {
    const phone1Value = watch('phone1');
    if (phone1Value) {
      console.log('Phone1 value:', phone1Value);
    }
  }, [watch('phone1')]);

  useEffect(() => {
    getInitFormData();
  }, []);

  const getInitFormData = async () => {
    setLoader(true);
    const userProfile = await getData(getThemeURL);
    const state_id = userProfile[0]?.state_id;
    setStateId(state_id);

    await getContactList();
    await getAgencyList();
    await getRegionList(state_id);
    await getResourceActivityList();
  
    if (id) {
      populateResourceFormFrEdit(id);
    } else {
      setValue("is_mandatory", "false");
    }
    setLoader(false);
  };
  
  useEffect(() => {
    const rscrcategory = getValues("rsrc_cat_id");
    const rscractivity = getValues("rsrc_activity_id");
    if (
      rscrcategory &&
      rscrcategory != "" &&
      rscractivity &&
      rscractivity != ""
    ) {
      getResourceNameList(rscractivity, rscrcategory);
    }
  }, [rscrcat]);

  useEffect(() => {
    const rscractivity = getValues("rsrc_activity_id");
    if (rscractivity && rscractivity != "") {
      getResourceCategoryList(rscractivity);
    }
  }, [rscractivity]);

  // Modified to handle standard multi-select change
  const handleRegionChange = (selectedOption) => {
    if (selectedOption) {
      console.log("Selected region ID:", selectedOption.value);
      
      // Check if this is actually a different region (for edit mode)
      if (id && resourcedataById) {
        const originalRegionId = resourcedataById.resource_region_map?.[0]?.region_id;
        if (originalRegionId && String(originalRegionId) === String(selectedOption.value)) {
          // Same region selected, don't clear facility or mark as changed
          setRegionDataSelected([{ region_id: selectedOption.value }]);
          getFacilityListByRegion(selectedOption.value);
          return;
        }
      }
      
      // Different region selected - clear facility and mark as changed
      isRegionChanged(true);
      setRegionDataSelected([{ region_id: selectedOption.value }]);
      
      // IMPORTANT: Clear the facility field when region changes
      setValue("facility_id", null, { shouldDirty: true, shouldTouch: true }); 
      
      // Also trigger form validation to ensure the field is properly cleared
      trigger("facility_id");
      
      // Clear facility data to show empty dropdown initially
      setFacilityData([]);
      
      // Update form config to clear facility options
      const updatedConfig = [...resourceConfig];
      updatedConfig[0].fields[9].options = [];
      setResourceConfig(updatedConfig);
      
      // Force the DOM element to clear if it exists
      const facilityElement = document.getElementById("facility_id");
      if (facilityElement) {
        facilityElement.value = "";
        facilityElement.dispatchEvent(new Event("change", { bubbles: true }));
      }
      
      // Fetch facilities based on the selected region
      getFacilityListByRegion(selectedOption.value);
    }
  };
  console.log(regionDataSelected,"dataaaaaaaaaaaaaaaasel")

  // New function to get facilities by region ID
  // Updated getFacilityListByRegion function
  const getFacilityListByRegion = async (regionId) => {
    if (!regionId) {
      console.log("No region ID provided for facility list");
      setFacilityData([]);
      return Promise.resolve([]);
    }
    
    // Only set region changing flag if user is actually changing region (not during initial load)
    if (id && resourcedataById) {
      const originalRegionId = resourcedataById.resource_region_map?.[0]?.region_id;
      if (originalRegionId && String(originalRegionId) !== String(regionId)) {
        setIsRegionChanging(true);
      }
    } else if (!id) {
      setIsRegionChanging(true);
    }
    
    setLoader(true);
    
    return new Promise((resolve, reject) => {
      try {
        console.log("Fetching facilities for region ID:", regionId);
        getData(facilityListByRegionId + regionId)
          .then(facilityList => {
            console.log("Received facility list:", facilityList);
            
            // Ensure we have an array to work with
            const facilities = Array.isArray(facilityList) ? facilityList : [];
            
            // Format facility data consistently
            const formattedFacilities = facilities.map(facility => ({
              id: facility.id,
              value: facility.id,
              label: facility.name || `Facility ${facility.id}`,
              name: facility.name || `Facility ${facility.id}`
            }));
            
            // Log the formatted facilities
            console.log("Formatted facilities:", formattedFacilities);
            
            // Update the form config and state
            const updatedConfig = [...resourceConfig];
            updatedConfig[0].fields[9].options = formattedFacilities;
            setResourceConfig(updatedConfig);
            setFacilityData(formattedFacilities);
            
            // Important: Only clear facility if region was actually changed by user
            if (isRegionChanging) {
              setValue("facility_id", null, { shouldDirty: true, shouldTouch: true });
              setIsRegionChanging(false);
            }
            
            setLoader(false);
            resolve(formattedFacilities);
          })
          .catch(error => {
            console.error("Error fetching facility list:", error);
            setFacilityData([]);
            const updatedConfig = [...resourceConfig];
            updatedConfig[0].fields[9].options = [];
            setResourceConfig(updatedConfig);
            setIsRegionChanging(false);
            setLoader(false);
            reject(error);
          });
      } catch (error) {
        console.error("Error in getFacilityListByRegion:", error);
        setFacilityData([]);
        const updatedConfig = [...resourceConfig];
        updatedConfig[0].fields[9].options = [];
        setResourceConfig(updatedConfig);
        setIsRegionChanging(false);
        setLoader(false);
        reject(error);
      }
    });
  };
  
  
  const getAgencyList = async () => {
    const userProfile = await getData(getThemeURL);
    const state_id = userProfile[0]?.state_id;
    var agencyList = await getData(`${agencyListURL}/${state_id}`);
    
    // Format the agency data
    for (let agency in agencyList) {
      agencyList[agency]["label"] = agencyList[agency]["name"];
      agencyList[agency]["value"] = agencyList[agency]["id"];
    }
    
    // Add default "Select" option at the beginning
    const agencyListWithDefault = [
      {
        id: "",
        value: "",
        label: "Select Agency",
        name: "Select Agency"
      },
      ...agencyList
    ];
    
    // Update the contact field configuration with the dynamic key
    resourceFormConfig[0].fields[10] = {
      ...resourceFormConfig[0].fields[10],
      key: `contact_list_${selectedAgency || 'none'}`
    };
    
    // Use the agency list with default option
    resourceFormConfig[0].fields[8]["options"] = agencyListWithDefault;
    setResourceConfig(resourceFormConfig);
    setAgencyData(agencyListWithDefault);
  };
  

  const getContactList = async (agencyId,clearContactData = false) => {
    setLoader(true);
    
    try {
      let contactList = [];
      setValue("contact_list", [], { shouldDirty: true, shouldTouch: true });
      if (agencyId) {
        // Fetch contacts for specific agency
        contactList = await getData(getContactsForAgency.replace("ID", agencyId));
      } else {
        // Fetch all contacts (fallback for initial load)
        const userProfile = await getData(getThemeURL);
        const state_id = userProfile[0]?.state_id;
        contactList = await getData(`${getContacts}/${state_id}`);
      }
  
      // Format contact data consistently
      const formattedContacts = contactList.map(contact => ({
        id: contact.id,
        value: contact.id,
        label: `${contact.name}, ${contact.job_title}, (${contact.phone1})`,
        name: contact.name,
        job_title: contact.job_title,
        phone1: contact.phone1
      }));
  
      // Update the form configuration with new contact options
      const updatedConfig = [...resourceConfig];
      updatedConfig[0].fields[10]["options"] = formattedContacts;
      setResourceConfig(updatedConfig);
      setContactData(formattedContacts);
  
      // Only repopulate contacts if we're not in the middle of an agency change
      if (!isAgencyChanging && id && resourcedataById) {
        populateContactDataFrEdit(resourcedataById,clearContactData);
      }
    } catch (error) {
      console.error("Error fetching contact list:", error);
      // Clear contacts on error
      const updatedConfig = [...resourceConfig];
      updatedConfig[0].fields[10]["options"] = [];
      setResourceConfig(updatedConfig);
      setContactData([]);
      setValue("contact_list", []);
    } finally {
      setLoader(false);
    }
  };
  
  const getRegionList = async (state_id) => {
    var regionList = await getData(getRestrictedRegionListURL.replace("STATEID", state_id));
  
    regionList.forEach((data) => {
      data.label += "   (District : " + data.district + ")";
    });
  
    // Configure for standard select (not hierarchical)
    resourceFormConfig[0].fields[7]["multiselect"] = false;
    resourceFormConfig[0].fields[7]["options"] = regionList;
    resourceFormConfig[0].fields[7]["onChange"] = handleRegionChange;
  
    setResourceConfig([...resourceFormConfig]);
    regionidlistGlobal = regionList;
    setRegionData(regionList);
  };

  const getResourceActivityList = async () => {
    const userProfile = await getData(getThemeURL);
    const state_id = userProfile[0]?.state_id;
    var resourceList = await getData(`${resourceActivityListURL}/${state_id}`);
    for (let resource in resourceList) {
      resourceList[resource]["label"] = resourceList[resource]["activity"];
      resourceList[resource]["value"] = resourceList[resource]["activity"];
    }
    resourceFormConfig[0].fields[0]["options"] = resourceList;
    setResourceConfig(resourceFormConfig);
    setResourceActivityList(resourceList);
    await getResourceCategoryList(resourceList[0]["activity"]);
  };
  
  const getResourceCategoryList = async (activity) => {
    const userProfile = await getData(getThemeURL);
    const state_id = userProfile[0]?.state_id;
    var resourceCategoryList = await getData(resourceCatListURL + activity + "?stateId=" + state_id);
    for (let resourceCat in resourceCategoryList) {
      resourceCategoryList[resourceCat]["label"] =
        resourceCategoryList[resourceCat]["category"];
      resourceCategoryList[resourceCat]["value"] =
        resourceCategoryList[resourceCat]["category"];
    }
    resourceFormConfig[0].fields[1]["options"] = resourceCategoryList;
    setResourceConfig(resourceFormConfig);
    setResourceCategoriesList(resourceCategoryList);
    setValue("rsrc_cat_id", resourceCategoryList[0].value);
    getResourceNameList(activity, resourceCategoryList[0].value);
  };
  
  const getResourceNameList = async (activity, category) => {
    let resourceNameList = [];
    resourceFormConfig[0].fields[2]["options"] = [];
    setResourceConfig(resourceFormConfig);
    setResourceNameList(resourceNameList);
    const userProfile = await getData(getThemeURL);
    const state_id = userProfile[0]?.state_id;
    resourceNameList = await getData(
      resourceNameListURL+"?activity="+ activity + "&category=" + category + "&stateId=" + state_id
    );
    for (let resourceName in resourceNameList) {
      resourceNameList[resourceName]["label"] =
        resourceNameList[resourceName]["name"];
      resourceNameList[resourceName]["value"] =
        resourceNameList[resourceName]["name"];
    }
    resourceFormConfig[0].fields[2]["options"] = resourceNameList;
    setResourceConfig(resourceFormConfig);
    setResourceNameList(resourceNameList);
  };

  const populateResourceFormFrEdit = async (id) => {
    setLoader(true);
    try {
      // Fetch resource data
      const resourceData = await postDataWithBody(findResourcesById, [id], {});
      console.log("resourceData=", resourceData);
      // Extract the first item if it's an array
      const resource = Array.isArray(resourceData) && resourceData.length > 0
        ? resourceData[0]
        : resourceData;
      console.log("Resource data to populate:", resource);

      
      if (resource.deploy_quantity !== undefined) {
        resource.deployed_quantity = resource.deploy_quantity;
      }

      setResourcedataById(resource);
      // IMPORTANT: Set the original agency ID for comparison
      if (resource.agency_id) {
        setOriginalAgencyId(resource.agency_id);
        console.log("Set original agency ID:", resource.agency_id);
      }
   
      const calculateAndSetAvailableQuantity = (resourceData) => {
        const total = parseInt(resourceData.total_quantity) || 0;
        const damaged = parseInt(resourceData.damaged_quantity) || 0;
        // UPDATE THIS LINE - Handle both field names
        const deployed = parseInt(resourceData.deploy_quantity) || 0;
        const available = total - damaged - deployed;
        setValue("available_quantity", available >= 0 ? available : 0);
      };
      // Reset form with initial data
      reset(resource);
      // Radio expects a string value; normalize the stored boolean
      setValue(
        "is_mandatory",
        resource.is_mandatory === true || resource.is_mandatory === "true" ? "true" : "false"
      );
      calculateAndSetAvailableQuantity(resource);
      // First populate the region
      const regionId = populateRegionDataFrEdit(resource);
      // Set the agency value first (this will trigger the useEffect)
      if (resource.agency_id) {
        setValue("agency_id", resource.agency_id);
        // Don't dispatch change event immediately - let the useEffect handle it
      }
      // Wait for facilities to load based on the region before populating facility
      if (regionId) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        await populateFacilityFormFrEdit(resource, regionId);
      }
      // Then set activity and category with proper delays
      setTimeout(() => {
        setValue("rsrc_activity_id", resource.rsrc_activity_id);
        document.getElementById("rsrc_activity_id")?.dispatchEvent(new Event("change", { bubbles: true }));
        setTimeout(() => {
          setValue("rsrc_cat_id", resource.rsrc_cat_id);
          document.getElementById("rsrc_cat_id")?.dispatchEvent(new Event("change", { bubbles: true }));
          getResourceNameList(resource.rsrc_activity_id, resource.rsrc_cat_id);
          setTimeout(() => {
            setValue("name", resource.name);
            setLoader(false);
          }, 1000);
        }, 1000);
      }, 1000);
    } catch (error) {
      console.error("Error in populateResourceFormFrEdit:", error);
      setLoader(false);
    }
  };
  const populateRegionDataFrEdit = (resourceData) => {
    console.log("All available regions:", regionData);
  
    if (resourceData.resource_region_map && resourceData.resource_region_map.length > 0) {
      const firstRegion = resourceData.resource_region_map[0];
      const regionId = firstRegion.region_id;
  
      console.log("Trying to find region with ID:", regionId);
  
      // Try to find the matching region
      const selectedRegion = regionData.find(region =>
        region.id === regionId ||
        String(region.id) === String(regionId) ||
        region.value === regionId ||
        String(region.value) === String(regionId)
      );
  
      const regionObj = selectedRegion
        ? {
            label: selectedRegion.label,
            value: selectedRegion.value ?? selectedRegion.id
          }
        : {
            label: `Region ID: ${regionId}`,
            value: regionId
          };
  
      console.log(selectedRegion ? "Found region match:" : "Using fallback region:", regionObj);
  
      // Set the form value for region
      setValue("region", regionObj);
  
      // IMPORTANT: Set regionChanged to false initially since this is the original region
      isRegionChanged(false);
  
      // Optionally set a separate variable for new region if required
      if (!selectedRegion && typeof setRegionNew === "function") {
        setRegionNew(regionObj);
      }
  
      // Update regionDataSelected state
      setRegionDataSelected([{ region_id: regionId }]);
  
      // Dispatch change event if needed
      const regionElement = document.getElementById("region");
      if (regionElement) {
        regionElement.dispatchEvent(new Event("change", { bubbles: true }));
      }
  
      // Fetch facilities
      getFacilityListByRegion(regionId);
  
      return regionId;
    }
  
    return null;
  };
  
  const populateFacilityFormFrEdit = async (resourceData, regionId) => {
    if (!resourceData || !resourceData.facility_id) {
      console.log("No facility ID in resource data");
      return;
    }
    
    const facilityId = resourceData.facility_id;
    console.log("Facility ID to populate:", facilityId);
    
    try {
      // If regionId was passed, use that; otherwise get it from resource data
      let regionIdToUse = regionId;
      if (!regionIdToUse && resourceData.resource_region_map && resourceData.resource_region_map.length > 0) {
        regionIdToUse = resourceData.resource_region_map[0].region_id;
      }
      
      if (!regionIdToUse) {
        console.log("No region ID available to fetch facilities");
        return;
      }
      
      // Fetch facilities for this region
      console.log("Fetching facilities for region ID:", regionIdToUse);
      const facilities = await getFacilityListByRegion(regionIdToUse);
      
      // After facilities are loaded, find the matching facility
      console.log("Looking for facility ID:", facilityId, "in facility list of length:", facilities.length);
      
      // Find the facility by ID with various comparison methods
      const selectedFacility = facilities.find(facility => 
        facility.id === facilityId || 
        String(facility.id) === String(facilityId) ||
        facility.value === facilityId ||
        String(facility.value) === String(facilityId)
      );
      
      if (selectedFacility) {
        console.log("Found facility match:", selectedFacility);
        
        // Format the facility value for the select component
        const formattedFacility = {
          label: selectedFacility.name || selectedFacility.label,
          value: selectedFacility.id || selectedFacility.value
        };
        
        console.log("Setting facility value:", formattedFacility);
        
        // Set the value without triggering validation errors
        setValue("facility_id", formattedFacility, { shouldValidate: false });
        
        // Also try to trigger change event
        setTimeout(() => {
          const facilityElement = document.getElementById("facility_id");
          if (facilityElement) {
            facilityElement.dispatchEvent(new Event("change", { bubbles: true }));
            console.log("Triggered change event on facility select");
          }
        }, 100);
      } else {
        // If we can't find the facility in our loaded data, create a fallback option
        console.log("Facility not found in loaded facilities");
        
        // Try to find facility name from the raw data if available
        let facilityName = `Facility ID: ${facilityId}`;
        if (resourceData.facility_name) {
          facilityName = resourceData.facility_name;
        } else if (Array.isArray(facilities) && facilities.length > 0) {
          // Get the name format from the first facility as a template
          facilityName = `Unknown Facility (ID: ${facilityId})`;
        }
        
        const fallbackFacility = {
          label: facilityName,
          value: facilityId
        };
        
        console.log("Using fallback facility:", fallbackFacility);
        
        // Add this facility to our options temporarily
        const updatedFacilities = [...facilityData, fallbackFacility];
        setFacilityData(updatedFacilities);
        
        // Update the form options
        const updatedConfig = [...resourceConfig];
        updatedConfig[0].fields[9].options = updatedFacilities;
        setResourceConfig(updatedConfig);
        
        // Set the value without triggering validation
        setValue("facility_id", fallbackFacility, { shouldValidate: false });
      }
    } catch (error) {
      console.error("Error in populateFacilityFormFrEdit:", error);
    }
  };
  
  useEffect(() => {
    if (inEdit && RegionNew?.value) {
      console.log(RegionNew.value, "RegionNew");
      getSpecificRegion(RegionNew.value);
    }
  }, [inEdit, RegionNew?.value]);
  
  console.log(RegionNew.value, "RegionNew")
  // // Add this utility function to handle specific region fetching if needed
  const getSpecificRegion = async (regionId) => {
    try {
      const specificRegionList = await getData(getRestrictedRegionListURL.replace("STATEID", stateId));
      console.log(specificRegionList, "specificRegionList");
  
      if (specificRegionList && Array.isArray(specificRegionList)) {
        const specificRegion = specificRegionList.find(item => item.value === RegionNew.value);
  
        if (specificRegion) {
          const formattedRegion = {
            id: specificRegion.id,
            value: specificRegion.id,
            label: `${specificRegion.label}   (District : ${specificRegion.district})`,
          };
  
          console.log("Retrieved specific region:", formattedRegion);
  
          setValue("region", formattedRegion);
          setRegionDataSelected([{ region_id: regionId }]);
          getFacilityListByRegion(regionId);
        } else {
          console.warn("Region ID not found in the list.");
        }
      }
    } catch (error) {
      console.error("Error fetching specific region:", error);
    }
  };
  
  const populateContactDataFrEdit = (resourceData,clearContactData = false) => {
    try {
      // Don't populate if user is actively changing agency
      if (isAgencyChanging) {
        console.log("Skipping contact population - agency is changing");
        return;
      }
   
      // Check if we have contact data to work with
      if (!resourceData?.resource_contact_map || !contactData.length) {
        console.log("No contact data available to populate");
        return;
      }
   
      console.log("Populating contact data for edit mode");
      console.log("Available contact data:", contactData);
      console.log("Resource contact map:", resourceData.resource_contact_map);
   
      // Create a map of all available contacts for quick lookup
      const contactMap = {};
      contactData.forEach(contact => {
        contactMap[contact.value || contact.id] = contact;
      });
   
      // Prepare the selected contacts array
      const selectedContacts = resourceData.resource_contact_map
        .map(resourceContact => {
          const contactId = resourceContact.contact_id;
          const contact = contactMap[contactId];
          if (contact) {
            return {
              label: contact.label || `${contact.name}, ${contact.job_title}, (${contact.phone1})`,
              value: contact.value || contact.id
            };
          }
          return null;
        })
        .filter(Boolean); // Remove any null entries
   
      console.log("Setting selected contacts:", selectedContacts);
      setValue("contact_list", clearContactData ? [] : selectedContacts);
    } catch (error) {
      console.error("Error in populateContactDataFrEdit:", error);
    }
  };
  
  const GenerateForm = (fields, register, errors, control) => {
    return (
      <div>
        {
          agencyData.length > 0 &&
          regionData.length > 0 &&
          resourceActivityList.length > 0 && (
            <FormHandler
              register={register}
              errors={errors}
              fields={fields}
              control={control}
              columns={2}
              getValues={getValues}
            />
          )}
      </div>
    );
  };
  
  const generateTabsData = (tabWiseData) => {
    tabWiseData?.forEach((element) => {
      return (element.component = GenerateForm(
        element?.fields,
        register,
        errors,
        control
      ));
    });
    return tabWiseData;
  };

  const submitHandler = async (data, e) => {
    e.preventDefault();
    setIsDisabled(true);
   
    // Extract facility_id from object to just the ID value
    if (data.facility_id && typeof data.facility_id === 'object') {
      data.facility_id = data.facility_id.value || data.facility_id.id;
    }
   
    delete data.deployed_quantity;

    // Send is_mandatory as a boolean: true = Mandatory, false = Optional
    data.is_mandatory = data.is_mandatory === true || data.is_mandatory === "true";
    // IMPORTANT: Process resource_region_map BEFORE removing region field
    data["resource_contact_map"] = getContactListFrUpsert();
    data["resource_region_map"] = getSanitizedRegionList(data);
    data["status"] = true;
   
    // Fetch and attach state_id
    const userProfile = await getData(getThemeURL);
    data["state_id"] = userProfile[0]?.state_id;
    
    // Remove the region object from the final payload since it's not needed by the API
    delete data.region;
   
    console.log("Final data being submitted:", JSON.stringify(data));
    let msg = null;
   
    if (id != null) {
      data.id = id;
      delete data["created_on"];
      delete data["updated_on"];
      var res = await putDataWithBody(updateResourceURL, data, {});
      msg = "Resource updated successfully.";
    } else {
      console.log("data phone number-------------", data.phone1);
      var res = await postDataWithBody(createResourceURL, data, {});
      msg = "Resource created successfully.";
    }
   
    toast.success(msg, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
    navToResourceList(res);
    setIsDisabled(false);
  };
  
  
  const getSanitizedRegionList = (data) => {
    const regionObj = data.region;
    
    if (!regionObj) {
      return [];
    }
    
    const selectedRegionId = regionObj.value || regionObj.id;
  
    if (id) {
      // For edit mode, check if region was actually changed
      if (regionChanged === true) {
        // Region was changed - use the new region
        if (selectedRegionId) {
          let existingRegionIdMap = {};
          if (resourcedataById && resourcedataById.resource_region_map) {
            resourcedataById.resource_region_map.forEach((region) => {
              existingRegionIdMap[region.region_id] = region.id;
            });
          }
  
          if (existingRegionIdMap[selectedRegionId]) {
            return [{
              region_id: selectedRegionId,
              id: existingRegionIdMap[selectedRegionId],
              resource_id: id,
            }];
          } else {
            return [{
              region_id: selectedRegionId,
              resource_id: id,
            }];
          }
        }
        return [];
      } else {
        // Region was NOT changed - return original region data
        if (resourcedataById && resourcedataById.resource_region_map) {
          return resourcedataById.resource_region_map;
        }
        return [];
      }
    } else {
      // Create mode
      if (selectedRegionId) {
        return [{ region_id: selectedRegionId }];
      }
      return [];
    }
  };
  

  const getContactListFrUpsert = () => {
    let selectedContact = getValues("contact_list");
    if (!selectedContact) {
      return [];
    }
    
    if (id) {
      let existingContactIdMap = {};
      resourcedataById.resource_contact_map.forEach((contact, index) => {
        existingContactIdMap[contact.contact_id] = contact.id;
      });
      let contactListdataNew = [];
      for (let contact in selectedContact) {
        let contactObj = selectedContact[contact];
        if (existingContactIdMap[contactObj["value"]]) {
          contactListdataNew.push({
            contact_id: contactObj["value"],
            id: existingContactIdMap[contactObj["value"]],
          });
        } else {
          contactListdataNew.push({ contact_id: contactObj["value"] });
        }
      }
      return contactListdataNew;
    } else {
      let contactListFrInsert = [];
      selectedContact.forEach((contact, index) => {
        contactListFrInsert.push({ contact_id: contact.value });
      });
      return contactListFrInsert;
    }
  };
  
  const navToResourceList = (msg) => {
    navigate("/resource-list");
  };

  const saveTabDataHandler = async (e) => {
    const isStepValid = await trigger();
    if (isStepValid) setActiveTab((prevId) => prevId + 1);
  };

  const previousHandler = () => {
    if (activeTab > 0) {
      setActiveTab((prevId) => prevId - 1);
    }
  };

  const tabsData = generateTabsData(resourceConfig);

  return (
    <div className="mt-4">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      <div className="form-body">
        <div className="registration__form--body">
          <form onSubmit={handleSubmit(submitHandler)} name="ResourceRegForm">
            <div>
              {tabsData?.map((tab) => (
                <>
                  {tab.id === activeTab && (
                    <>
                      <div className="registration__form--heading">
                        {tab.heading}
                      </div>
                      <div>{tab.component}</div>
                    </>
                  )}
                </>
              ))}
            </div>

            <div className="d-flex justify-content-center">
              {activeTab > 0 && (
                <Button
                  variant="secondary"
                  className="previousbutton-style mx-2"
                  onClick={previousHandler}
                >
                  Previous
                </Button>
              )}
              {tabsData.length - 1 === activeTab && (
              <Button type="submit" className="mx-2" variant="primary" disabled={isDisabled}>
                {edit ? "Update" : t('saveAndSubmit')}
              </Button>
              )}
              {tabsData.length - 1 !== activeTab && (
                <Button
                  variant="primary"
                  className="mx-2"
                  onClick={saveTabDataHandler}
                >
                  Save & Next
                </Button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateResourceRegForm;